import { useTheme } from 'next-themes';
import React, { useMemo } from 'react';

type Props = {
  lightImg: string;
  darkImg?: string;
  className?: string;
  alt: string;
};

const ThemeImg = ({ lightImg, darkImg, className, alt }: Props) => {
  const { theme } = useTheme();
  const imagePath = useMemo(() => {
    if (theme === 'dark') {
      return darkImg || lightImg;
    } else if (theme === 'light') {
      return lightImg;
    }
  }, [theme, darkImg, lightImg]);

  return <img className={`${className}`} src={imagePath} alt={alt} />;
};

export default ThemeImg;
